export default {
    id: "photographs",
    titleKey: {
      zh: "摄影作品",
      en: "Photographs"
    },
    descriptionKey: {
      zh: "捕捉生活中的光影瞬间。",
      en: "Capturing moments of light and shadow."
    },
    items: [
      {
        id: "ph1",
        titleKey: { zh: "腾讯滨海大厦", en: "Tencent Binhai Tower" },
        image: require('@/assets/images/photos/IMG_20240817_205326_Tencent.webp'),
        descriptionKey: { zh: "结束封闭培训回深圳时，刚好是不错的天气", en: "When I returned to Shenzhen after the closed training, the weather was good." },
        date: { year: 2024, month: 8 },
        location: { zh: "深圳", en: "Shenzhen"}
      },
      {
        id: "ph2",
        titleKey: { zh: "带小梓上山顶", en: "Take Xiao Zi to the Top of the Mountain" },
        image: require('@/assets/images/photos/IMG_20241011_175144.webp'),
        descriptionKey: { zh: "带着小梓挂件上到危险的山顶，这座山非常难爬！但是山顶全是人。", en: "Take Xiao Zi to the top of the dangerous mountain, this mountain is very difficult to climb! But the山顶全是人。" },
        date: { year: 2024, month: 10 },
        location: { zh: "广西", en: "Guangxi"}
      },
      {
        id: "ph3",
        titleKey: { zh: "探索禁地", en: "Explore Forbidden Territory" },
        image: require('@/assets/images/photos/IMG_20241020_160314.webp'),
        descriptionKey: { zh: "在大学城的图书馆顶楼探索，前有绝景。", en: "Explore the library rooftop in the university city, with a panoramic view." },
        date: { year: 2024, month: 10 },
        location: { zh: "深圳", en: "Shenzhen"}
      },
      {
        id: "ph4",
        titleKey: { zh: "海边写信", en: "Writing a Letter by the Sea" },
        image: require('@/assets/images/photos/IMG_20241117_175724.webp'),
        descriptionKey: { zh: "在深圳湾观桥公园写《于荧露树林（中）》", en: "Writing 'In the Firefly Woods (Middle)' at the Shenzhen Bay Observation Bridge Park." },
        date: { year: 2024, month: 11 },
        location: { zh: "深圳湾", en: "Shenzhen Bay"}
      },
      {
        id: "ph8",
        titleKey: { zh: "【Kigurumi】DW11场照", en: "[Kigurumi] DW11 Event Photo" },
        image: require('@/assets/images/photos/IMG_20241123_170020.webp'),
        descriptionKey: { zh: "变娃去Kigurumi展，这张感觉很可爱。", en: "Dressed as a doll at the Kigurumi exhibition, this one feels very cute." },
        date: { year: 2024, month: 11 },
        location: { zh: "广州", en: "Guangzhou" }
      },
      {
        id: "ph6",
        titleKey: { zh: "【Kigurumi】DW11场照", en: "[Kigurumi] DW11 Event Photo" },
        image: require('@/assets/images/photos/IMG_20241123_150444.webp'),
        descriptionKey: { zh: "变娃去Kigurumi展，展会有很多娃娃", en: "Dressed as a doll at the Kigurumi exhibition, there were many dolls at the event." },
        date: { year: 2024, month: 11 },
        location: { zh: "广州", en: "Guangzhou" }
      },
      {
        id: "ph5",
        titleKey: { zh: "【Kigurumi】DW11场照", en: "[Kigurumi] DW11 Event Photo" },
        image: require('@/assets/images/photos/IMG_20241123_144702.webp'),
        descriptionKey: { zh: "变娃去Kigurumi展，这是我在舞台前拍签到照。", en: "Dressed as a doll at the Kigurumi exhibition, this is a photo I took in front of the stage." },
        date: { year: 2024, month: 11 },
        location: { zh: "广州", en: "Guangzhou" }
      },
      {
        id: "ph7",
        titleKey: { zh: "【Kigurumi】DW11场照", en: "[Kigurumi] DW11 Event Photo" },
        image: require('@/assets/images/photos/IMG_20241123_152122.webp'),
        descriptionKey: { zh: "变娃去Kigurumi展，这只伊蕾娜很撩诶...", en: "Dressed as a doll at the Kigurumi exhibition, this Elena is quite charming..." },
        date: { year: 2024, month: 11 },
        location: { zh: "广州", en: "Guangzhou" }
      },
      {
        id: "ph9",
        titleKey: { zh: "【Kigurumi】万圣节", en: "[Kigurumi] Halloween" },
        image: require('@/assets/images/photos/IMG_20241131_015057.webp'),
        descriptionKey: { zh: "万圣节变娃自拍。当晚换了许多套衣服来拍，也为Return那一幅画找了穿搭。用画图软件补橙色光哈哈哈，效果还不错。", en: "Halloween doll selfie. I changed into many outfits that night for the photos, and also found an outfit for the painting 'Return'. I used a drawing software to add orange light to the photo, and it turned out pretty well." },
        date: { year: 2024, month: 11 },
        location: { zh: "深圳", en: "Shenzhen"}
      }
    ]
}